import React, { useState, useEffect, useCallback, useRef } from 'react';
import { createPortal } from 'react-dom';
import '../../../FlowchartView/components/NestModal/NestModal.css';
import './CompileIntoNestedModal.css';

/**
 * Modal to name the new wrapper mission before compiling selected missions into its nested campaign.
 */
const CompileIntoNestedModal = ({
  isOpen,
  selectedCount = 0,
  onConfirm,
  onCancel,
}) => {
  const [name, setName] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setName('');
      const t = requestAnimationFrame(() => inputRef.current?.focus?.());
      return () => cancelAnimationFrame(t);
    }
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onCancel?.();
      } else if (e.key === 'Enter' && name.trim()) {
        onConfirm?.(name.trim());
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, name, onConfirm, onCancel]);

  const handleConfirm = useCallback(() => {
    const trimmed = name.trim();
    if (!trimmed) return;
    onConfirm?.(trimmed);
  }, [name, onConfirm]);

  if (!isOpen) return null;

  return createPortal(
    <div className="nest-modal__overlay" onClick={onCancel}>
      <div className="nest-modal compile-into-nested-modal" onClick={(e) => e.stopPropagation()}>
        <div className="nest-modal__header">
          <div className="nest-modal__icon">📦</div>
          <div className="nest-modal__title">
            Name the new mission
          </div>
        </div>
        <p className="compile-into-nested-modal__hint">
          {selectedCount} missions will be moved into a nested campaign inside this new mission.
        </p>
        <label className="compile-into-nested-modal__label" htmlFor="compile-nested-mission-name">
          Mission name
        </label>
        <input
          id="compile-nested-mission-name"
          ref={inputRef}
          className="compile-into-nested-modal__input"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="e.g. Phase 1 — Discovery"
          autoComplete="off"
        />
        <div className="nest-modal__actions">
          <button type="button" className="nest-modal__btn nest-modal__btn--cancel" onClick={onCancel}>
            Cancel
          </button>
          <button
            type="button"
            className="nest-modal__btn nest-modal__btn--confirm"
            onClick={handleConfirm}
            disabled={!name.trim()}
          >
            Compile
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default CompileIntoNestedModal;
